export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获得预约总数
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/get_subscribe_count

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "subscribe_total": 0,
	        "session_id": "ffxYlMErIrDlX19Cl8mK7cI8aiwTctJc5wH5JCsg",
	        "request_id": "90982a121c1e9a2d05c9f4bc330ca72eeb9ecff9"
	    }
	 }
		*/
  service.getSubscribeCount = function() {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/get_subscribe_count', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "subscribe_total": "预约总数"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得基本信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/get_config

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "uid": "4f1d0b282b4ff2ad35f1b094fcbf4537",
	        "phone": "159***519",
	        "invite_count": 0,
	        "add_wx_manager": 1,
	        "add_wx_account": 1,
	        "share_friend": 0,
	        "lottery_time": 5,
	        "m_login_token": "88e0b4c26da7827a201450306322f94c",
	        "open_id": "3test_openid_12232112224",
	        "subscribe_msg": [],
	        "session_id": "Btxg54yoIAY4anDGNdPYGM79uiqhxPE8bQ5xMWQZ",
	        "request_id": "ea4832d8223d49f2163572938fbbf08229ff9878"
	    }
	 }
		*/
  service.getConfig = function(is_wx, token) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/get_config', {
      is_wx: is_wx /*  是否是微信小程序（1：是，0：不是），不传该字段默认为0 */ ,
      token: token /*  小程序二维码token信息 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "add_wx_account": "是否已完成添加微信公众号任务（1：是，0：否）",
            "add_wx_manager": "是否已完成添加微信管家任务（1：是，0：否）",
            "invite_count": "邀请好友预约总数",
            "is_subscribe_msg": "是否已订阅微信信息（is_wx为1才会有该字段，1：是，0：否）",
            "lottery_time": "抽奖次数",
            "m_login_token": "移动端登录token",
            "open_id": "返回字段说明",
            "phone": "手机号:敏感信息",
            "share_friend": "是否已完成分享朋友圈任务（1：是，0：否）",
            "subscribe_msg": "返回字段说明",
            "subscribe_total": "预约总数",
            "test_download_status": "测试下载开放状态（1：是，0：否）",
            "uid": "分享uid"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20124",
        "description": "该二维码已被使用请重新扫码授权登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		发送手机号验证码
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/get_phone_code?phone=17878351579

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "nCXJT5BQQRZ54dby6UakkohiQibS1UxiFxQrp5kz",
	        "request_id": "87a807c6f0d0a384eb907de7a2eaac1d31e06c98"
	    }
	 }
		*/
  service.getPhoneCode = function(phone) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/get_phone_code', {
      ...phone /*  手机号 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10308",
        "description": "短信验证码发送数量达到每日上限"
      }, {
        "code": "-10309",
        "description": "短信验证码发送频率太快"
      }, {
        "code": "-10316",
        "description": "参数缺失"
      }, {
        "code": "-10317",
        "description": "参数类型错误"
      }, {
        "code": "-10601",
        "description": "图片验证码为空"
      }, {
        "code": "-10602",
        "description": "图片验证码错误"
      }, {
        "code": "-10603",
        "description": "极验验证失败"
      }, {
        "code": "-10604",
        "description": "图片验证码参数错误"
      }, {
        "code": "-10605",
        "description": "图片验证码已过期，请重新刷新"
      }, {
        "code": "-10606",
        "description": "顶象验证失败"
      }, {
        "code": "-12304",
        "description": "手机号OpenId参数缺失"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		预约（pc或h5）
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/subscribe?a=123123&platform=iOS&phone=15913351672&code=123123&invitee_uid=4f1d0b282b4ff2ad35f1b094fcbf4537

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_frist": 1,
	        "uid": "474fa6ed7d374fd501ed42f12dc96670",
	        "phone": "183***479",
	        "session_id": "ybwuIeHiXePA9VvjlHUExMyzrySlg1JzbwvPyGtU",
	        "request_id": "3bcb8cbb55c4c94d09780079fcdd74f6437e4a4b"
	    }
	 }
		*/
  service.subscribe = function(a, code, device_id, invitee_uid, operate_from, phone, platform, ua_os, utm_source) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/subscribe', {
      a: a /*  参数说明 */ ,
      code: code /*  手机号验证码 */ ,
      device_id: device_id /*  设备id */ ,
      invitee_uid: invitee_uid /*  分享人uid */ ,
      operate_from: operate_from /*  pc=电脑端，h5=h5端 */ ,
      phone: phone /*  手机号 */ ,
      platform: platform /*  平台类型（iOS 或 Android 或 PC 或 Harmony） */ ,
      ua_os: ua_os /*  ua中的操作系统 */ ,
      utm_source: utm_source /*  utm_source */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "is_frist": "是否首次预约（1：是，0：否）",
            "phone": "手机号:敏感信息",
            "uid": "分享uid"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-10315",
        "description": "短信验证码已经被验证过，请重新获取"
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20106",
        "description": "无效的分享id"
      }, {
        "code": "-20107",
        "description": "平台类型错误"
      }, {
        "code": "-20128",
        "description": "网络繁忙，请稍后再试"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		小程序预约
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/subscribe_by_wx?token=0e737f214453bb6f833134950b5481b3&code=123123&ua_os=Harmony 17.3&utm_source=bdsem&device_id=123132123&operate_from=miniprogram&platform=Harmony&invitee_uid=0e737f214453bb6f833134950b5481b0

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_frist": 1,
	        "uid": "5b328b8328f9d96a969eeba7b6f043bb",
	        "phone": "183***472",
	        "session_id": "ybwuIeHiXePA9VvjlHUExMyzrySlg1JzbwvPyGtU",
	        "request_id": "fe5327ac8e9b72ef4e5f972496d53f6bd1adf7b2"
	    }
	 }
		*/
  service.subscribeByWx = function(token, code, ua_os, utm_source, device_id, operate_from, platform, invitee_uid) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/subscribe_by_wx', {
      token: token /*  小程序二维码token信息 */ ,
      code: code /*  微信获取绑定手机号返回code */ ,
      ua_os: ua_os /*  ua中的操作系统 */ ,
      utm_source: utm_source /*  utm_source */ ,
      device_id: device_id /*  设备id */ ,
      operate_from: operate_from /*  （pc_yyz=电脑端，h5_yyz=h5端，miniprogram_yyz=小程序） */ ,
      platform: platform /*  平台类型（iOS 或 Android 或 PC 或 Harmony） */ ,
      invitee_uid: invitee_uid /*  分享人uid */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "is_frist": "返回字段说明",
            "phone": "手机号:敏感信息",
            "uid": "分享uid"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20106",
        "description": "无效的分享id"
      }, {
        "code": "-20107",
        "description": "平台类型错误"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20117",
        "description": "获取微信绑定手机号失败"
      }, {
        "code": "-20124",
        "description": "该二维码已被使用请重新扫码授权登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得小程序二维码
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/get_qr_code?data_str=bdsem&env_version=develop&page=/index

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "img": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQ",
	        "pc_login_token": "df399c23b9b914091d9421457de807a3",
	        "effective_time": 300,
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "254365b84ab0d78c90896c7be2a0cf5c525ffedf"
	    }
	 }
		*/
  service.getQrCode = function(data_str, env_version, page) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/get_qr_code', {
      data_str: data_str /*  埋点参数（百度sem等,必传） */ ,
      env_version: env_version /*  小程序版本（正式版:release 体验版:trial 开发版:develop） */ ,
      page: page /*  小程序应该跳转到对应页面 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "effective_time": "二维码有效时间",
            "img": "小程序二维码",
            "pc_login_token": "pc登录token"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20120",
        "description": "获取二维码失败，请重试！"
      }, {
        "code": "-20121",
        "description": "网络繁忙，请稍后再试！"
      }, {
        "code": "-20123",
        "description": "您已预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		通过token获得pc埋点信息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/get_data_str_by_token?token=070e59eb1d269920938dd2f7a2321081

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "data_str": "bdsem",
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "97709ba814426e8675e404ec63d43584e5b1af84"
	    }
	 }
		*/
  service.getDataStrByToken = function(token) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/get_data_str_by_token', {
      token: token /*  token信息 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "data_str": "埋点信息"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20122",
        "description": "小程序二维码已过期，请刷新页面后再扫码登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		pc端二维码检测小程序预约情况
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/check_pc_login_status?token=070e59eb1d269920938dd2f7a2321081

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_login": 0,
	        "display_phone": "",
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "50c0e55eaaddcd94ec803260be7b274d54ef8d04"
	    }
	 }
		*/
  service.checkPcLoginStatus = function(token) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/check_pc_login_status', {
      token: token /*  token信息 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "display_phone": "展示手机号",
            "is_login": "是否已预约（1：已预约，0：未预约）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		完成相关任务
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/done_mission?device_id=12312311&entrance=pc&type=1&ua_os=iOS 1.7

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "63b92cce95736f967dc2b3de50b26fa0f638dab8"
	    }
	 }
		*/
  service.doneMission = function(device_id, entrance, type, ua_os) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/done_mission', {
      device_id: device_id /*  设备id */ ,
      entrance: entrance /*  入口（pc=电脑端, h5=移动端, official=公众号） */ ,
      type: type /*  任务类型:2=关注微信公众号 */ ,
      ua_os: ua_os /*  ua中的操作系统 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20103",
        "description": "任务类型异常"
      }, {
        "code": "-20104",
        "description": "您已完成该任务"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20130",
        "description": "请先添加企微好友"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽奖
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/lottery?device_id=112122&entrance=pc&ua_os=iOS1.7

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "prize_id": 6,
	        "prize_type": 1,
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "48bb3c9c0ba095752f5fb8e4e8be607f9d891f84"
	    }
	 }
		*/
  service.lottery = function(device_id, entrance, ua_os) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/lottery', {
      device_id: device_id /*  设备id */ ,
      entrance: entrance /*  入口（pc=电脑端, h5=移动端, official=公众号） */ ,
      ua_os: ua_os /*  ua中的操作系统 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "prize_id": "奖励id",
            "prize_type": "奖励类型:1=虚拟奖励,2=实物奖励"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20108",
        "description": "抽奖次数不足"
      }, {
        "code": "-20109",
        "description": "请先完善配置"
      }, {
        "code": "-20110",
        "description": "网络异常，请稍后重试"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		我的奖励
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/my_prize

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "virtual_prize": [
	            {
	                "create_time": 1745743240,
	                "prize_id": 6
	            }
	        ],
	        "truth_prize": [
	            {
	                "create_time": 1745743638,
	                "prize_id": 3
	            }
	        ],
	        "address_info": {
	            "addressee": "阿飞",
	            "contact_phone": "183***268",
	            "address": "广东珠海金山软件园"
	        },
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "e0c3d154a888c877b6f8a3d034dda15f8e3494dd"
	    }
	 }
		*/
  service.myPrize = function() {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/my_prize', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "address_info": "地址信息",
            "truth_prize": "实物奖励",
            "virtual_prize": "虚拟奖励"
          },
          "data{}.address_info{}": {
            "address": "收件地址",
            "addressee": "收件人",
            "contact_phone": "联系手机号:敏感信息"
          },
          "data{}.truth_prize[]": {
            "create_time": "创建时间",
            "prize_id": "奖励id"
          },
          "data{}.virtual_prize[]": {
            "create_time": "创建时间",
            "prize_id": "奖励id"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		设置收件地址
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/set_address?addressee=阿飞&contact_phone=18316023268&address=广东珠海金山软件园

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "e8989c8c90f7f1e3c5ba9830417ef9c16b51756f"
	    }
	 }
		*/
  service.setAddress = function(addressee, contact_phone, address) {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/set_address', {
      addressee: addressee /*  收件人 */ ,
      contact_phone: contact_phone /*  联系手机号 */ ,
      address: address /*  收件地址 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20111",
        "description": "您已填写收款地址，无法重新填写"
      }, {
        "code": "-20112",
        "description": "您未获得实物奖励"
      }, {
        "code": "-20113",
        "description": "请填写完整的收件信息"
      }, {
        "code": "-20114",
        "description": "收件人名称涉及敏感词汇，请修改"
      }, {
        "code": "-20115",
        "description": "收件地址涉及敏感词汇，请修改"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		订阅消息
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/subscribe_msg

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "4466674e9cf276576ece4b7ee0b9a20cf6143e38"
	    }
	 }
		*/
  service.subscribeMsg = function() {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/subscribe_msg', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20126",
        "description": "模板ID不能为空"
      }, {
        "code": "-20127",
        "description": "模板ID异常"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		退出登录
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/logout

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "f39848f89ae032158348bd97dcbecf0417847211"
	    }
	 }
		*/
  service.logout = function() {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/logout', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		奖品列表
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/prize_list

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "prize_list": [
	            {
	                "prize_id": 1,
	                "prize_name": "10g 金条",
	                "prize_type": 2,
	                "prize_icon": ""
	            },
	            {
	                "prize_id": 2,
	                "prize_name": "萌宠捏捏乐·桃桃",
	                "prize_type": 2,
	                "prize_icon": ""
	            },
	            {
	                "prize_id": 3,
	                "prize_name": "神兽玩偶·白泽",
	                "prize_type": 2,
	                "prize_icon": ""
	            },
	            {
	                "prize_id": 4,
	                "prize_name": "玄晶*5",
	                "prize_type": 1,
	                "prize_icon": ""
	            },
	            {
	                "prize_id": 5,
	                "prize_name": "灵宠经验丹（中）*2",
	                "prize_type": 1,
	                "prize_icon": ""
	            },
	            {
	                "prize_id": 6,
	                "prize_name": "一袋银叶",
	                "prize_type": 1,
	                "prize_icon": ""
	            },
	            {
	                "prize_id": 7,
	                "prize_name": "博珍图",
	                "prize_type": 1,
	                "prize_icon": ""
	            },
	            {
	                "prize_id": 8,
	                "prize_name": "无忧教的财宝*1",
	                "prize_type": 1,
	                "prize_icon": ""
	            }
	        ],
	        "session_id": "WA3BMGqASFQteT5gEReUCrVmYem6OKYXVI1KIQcd",
	        "request_id": "408af3565914f0735aba452fe01fa2a47b25d5ff"
	    }
	 }
		*/
  service.prizeList = function() {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/prize_list', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "prize_list": "奖品列表"
          },
          "data{}.prize_list[]": {
            "prize_icon": "奖品icon",
            "prize_id": "奖励id",
            "prize_name": "奖品名称",
            "prize_type": "奖励类型:1=虚拟奖励,2=实物奖励"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得查询奖励链接
		请求方法: GET, POST
		请求示例: http://<domain>/jxsjmobile4/jxsjm4yy250425/get_check_prize_url

	响应示例:

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "check_prize_url": "https://test-zt.xoyo.com/js4.seasungames.cn/p/m/2025/07/15/reward-inquiry",
	        "session_id": "oebVxsFZ4pGPn7YQFiBfhukT87vGUMQug1qkoVNE",
	        "request_id": "4c9ed622ae5484ba5b02ef885c922cbf531f90e0"
	    }
	 }
		*/
  service.getCheckPrizeUrl = function() {
    return request.jsonp(rootAddress + '/jxsjmobile4/jxsjm4yy250425/get_check_prize_url', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "check_prize_url": "查询奖励专题页面链接"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20129",
        "description": "活动暂未开放，敬请期待"
      }]
      		*/
      return reject(response);
    });
  };
  return service;
}
